import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RoleGroupService } from './../../../_services/role-group.service';

@Component({
  selector: 'app-role-group-create',
  templateUrl: './role-group-create.component.html',
  styleUrls: ['./role-group-create.component.css']
})
export class RoleGroupCreateComponent implements OnInit {
  roleGroupForm: FormGroup;
  server_role_group_id=0
  isSaving: boolean = false;
  errorSaving: boolean = false;

  constructor(private roleGroupService: RoleGroupService, private router: Router, private activatedRoute:ActivatedRoute) {}

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.server_role_group_id = params['server_role_group_id'];
      if (this.server_role_group_id) {
        this.roleGroupService.getRoleGroupName(this.server_role_group_id).subscribe({
          next: (data) => {
            this.roleGroupForm.patchValue({
              name: data.rs.data.name,
              description: data.rs.data.description
            });
          },
          error: (err) => {
            console.error('Error fetching RoleGroup:', err);
            this.errorSaving = true;
          }
        });
      }
    });
    this.initForm();
  }

  initForm(): void {
    this.roleGroupForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.minLength(3)]),
      description: new FormControl('', [Validators.required, Validators.minLength(5)])
    });
  }

  onSubmit(): void {
    if (this.roleGroupForm.invalid) {
      return;
    }

    this.isSaving = true;
    let dd=this.formatData(this.roleGroupForm.value.name,this.roleGroupForm.value.description)
    this.roleGroupService.createRoleGroup(dd).subscribe({
      next: () => {
        this.isSaving = false;
        this.router.navigate(['/admin/roles/index']);
      },
      error: (err) => {
        console.error('Error creating RoleGroup:', err);
        this.isSaving = false;
        this.errorSaving = true;
      }
    });
  }


  formatData(name:string, description:string){
    let data = new URLSearchParams();
    data.set('name', name);
    data.set('description', description);
    data.set('server_role_group_id', this.server_role_group_id.toString());


    return data.toString()
  }



}
